import { render, staticRenderFns } from "./agregarTarea.vue?vue&type=template&id=1f8aa706&scoped=true"
import script from "./agregarTarea.vue?vue&type=script&lang=js"
export * from "./agregarTarea.vue?vue&type=script&lang=js"
import style0 from "./agregarTarea.vue?vue&type=style&index=0&id=1f8aa706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8aa706",
  null
  
)

export default component.exports